export class BatchedOperationError<TBatch, TAggregate> extends Error {
  public partialResult: TAggregate
  public failedBatch: TBatch
  public cause: unknown

  constructor(params: { message: string; partialResult: TAggregate; failedBatch: TBatch; cause?: unknown }) {
    super(params.message)
    this.name = 'BatchedOperationError'
    this.partialResult = params.partialResult
    this.failedBatch = params.failedBatch
    this.cause = params.cause
  }
}
